import AddIcon from '@mui/icons-material/Add';
import { CircularProgress, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import { useNotes } from '../../../sic-lib/api/hooks/useNotes';
import { Contact } from '../../../sic-lib/types/Contact';
import ToggleComponents from '../../Shared/ToggleComponents/ToggleComponents';
import ContactNoteCreate from './ContactNoteCreate';
import ContactNoteDisplay from './ContactNoteDisplay';
import ContactNoteEdit from './ContactNoteEdit';

interface Props {
    contact: Contact;
}

export default function ContactNotes({ contact }: Props) {
    const { classes, cx } = useStyles();

    const { data: notes, isLoading } = useNotes(contact.contactId);

    return (
        <div className={cx(classes.root, 'scrollWrapper--hideScrollbar')}>
            <Stack direction="column" spacing={1} p={2}>
                <ToggleComponents>
                    {(toggle, setToggle) =>
                        !toggle ? (
                            <div className={classes.buttonWrapper}>
                                <Button
                                    className={classes.btnComposeNote}
                                    onClick={setToggle}
                                    startIcon={<AddIcon />}
                                >
                                    Compose Note
                                </Button>
                            </div>
                        ) : (
                            <ContactNoteCreate
                                contactId={contact.contactId}
                                onToggleHandler={setToggle}
                            />
                        )
                    }
                </ToggleComponents>
                {isLoading && <CircularProgress sx={{ alignSelf: 'center' }} />}
                {notes?.map(nte => (
                    <ToggleComponents key={nte.noteId}>
                        {(toggle, setToggle) =>
                            !toggle ? (
                                <ContactNoteDisplay
                                    note={nte}
                                    contact={contact}
                                    onToggleHandler={setToggle}
                                />
                            ) : (
                                <ContactNoteEdit
                                    contact={contact}
                                    note={nte}
                                    onToggleHandler={setToggle}
                                />
                            )
                        }
                    </ToggleComponents>
                ))}
            </Stack>
        </div>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: '100%',
    },
    flexWrapper: {
        height: '100%',
    },
    flexChild: {
        padding: theme.spacing(0, 1),
    },
    buttonWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    btnComposeNote: {
        color: theme.palette.addButton.main,
        '&:hover': {
            backgroundColor: theme.palette.addButton.light,
        },
    },
}));
